import { Icon } from '@/types/icon';

/**
 * Processes icon data and returns a clean URL ready for use
 */
export function processIcon(icon: Icon | undefined | null): string {
  if (!icon?.icon) return '';
  
  const iconData = icon.icon.trim();
  
  // Clean base64 data URLs by removing whitespace
  if (iconData.startsWith('data:')) {
    return iconData.replace(/\s+/g, '');
  }
  
  // Convert relative paths to absolute
  if (iconData.startsWith('./')) {
    return iconData.replace('./', '/');
  }
  
  return iconData;
}

/**
 * Checks if icon has valid display data
 */
export function hasValidIcon(icon: Icon | undefined | null): boolean {
  return !!(icon?.icon?.trim());
}

/**
 * Gets alt text for an icon
 */
export function getIconAlt(icon: Icon | undefined | null, fallback: string = ''): string {
  return icon?.description?.trim() || fallback;
}

